import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GameAttemptResult, LessonGamePlay } from 'src/app/models/module/lessongame.model';

@Component({
  selector: 'app-lesson-game',
  templateUrl: './lesson-game.component.html',
  styleUrls: ['./lesson-game.component.css']
})
export class LessonGameComponent {
  @Input() game: LessonGamePlay;
  @Output() attempted = new EventEmitter<GameAttemptResult>();

  onAttempted(result: GameAttemptResult): void {
    this.attempted.emit(result);
  }

  get gameTypeLabel(): string {
    switch (this.game?.gameType) {
      case 'match': return 'Match';
      case 'sequence': return 'Sequence';
      case 'flashcard': return 'Flashcards';
      default: return '';
    }
  }
}
